module.exports = __webpack_public_path__ + "img/sakuya izayoi_lw.99f69457.png";